export const locale = {
    lang: 'nl',
    data: {
        'NAV': {
            'APPLICATIONS': 'Toepassingen',
            'CONFIG': 'Instellingen',
            'TOOLS': {
              'TITULO': 'Gereedschap',
              'CHAT': 'Chat',
              'TODO': 'To-Do lijst',
              'BROKER': 'Configuratie door makelaar',
              'CHANGELOG': 'Wijzigingslog',
              'KNOWLEDGE': 'Kennis basis',
              'WEB_COM_PROF':'Web bedrijfsprofiel',
            },
            'RESULTS': {
              'TITULO': 'Resultaten',

              'ENLACES': {
                'TI': 'Rapportage',
                'TI_ESPANA': 'Online-rapporten',
                'COVID': 'Resultaten van de COVID-enquête'
              },
              'ENLACES5': {
                'TI': 'Resultaat 5.0',
                'COVID': 'Covid-onderzoek herroept'
              },
              'ENLACES_ACTION_GO':{
                'TITULO':'ActionGo',
                // 'TITULO':'Actieplan - Leiders',
              },
              'ENLACES_GO_FLOW':{
                'TITULO':'Go Flow Resultaten',
              }
            },
            'ACADEMY'        : {
                'TITULO': 'Test-Academie',
                'BADGE': '69'
            },
            'CERTIFICAR'        : {
                'TITULO': 'Certificeren',
                'TITULOIZZI': 'Izzi',
                'TITULO_ESPAIN': 'Diagnose',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Certificeren',
                  '1': 'Certificaat 2.0',
                  '2': 'Izzi',
                  '3': 'Certificaat 3.0',
                  '4': 'Certificeer zilver',
                  'SPA': 'Configuratie enquête'
                }
            },
            'CERTIFICARN35'        : {
                'TITULO': 'Certificeren N35',
                'BADGE': '69'
            },
            'MEDIR'        : {
                'TITULO': 'Meting',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Meting',
                  '1': 'Meting verbeterd',
                  '2': 'Meting + MST',
                  '3': 'Meting per oppervlakte',
                  '4': 'Meting door leiders',
                  '5': 'Meting op basis van de afmetingen',
                  '6': 'Te certificeren meting',
                  '7': 'Meting 3.0',
                }
            },
            'PULSE' : {
                'TITULO': 'Pulse Check',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'Pulse Check',
                  '1': 'Pulse Check 3.0',
                }
            },
            'FOCUS' : {
                'TITULO': 'Focusgebied',
                'BADGE': '69'
            },
            'ENCUESTAS' : {
                'TITULO': 'Bijkomende certificaties',
                'BADGE': '69',
                'SUBPRODUCTOS': {
                  '0': 'AMCO',
                  '1': 'Behoorlijk werk',
                  '2': 'Eerste baan',
                }
            },
            'NORMA35': {
                'TITULO': 'Norm 035'
            },
            'NOM35BETHE': {
                'TITULO': 'Norm 035 better'
            },
            'NOM35PLA': {
                'TITULO': 'Norm 035 silver'
            },
            'NOM35V3': {
                'TITULO': 'Norm 035 3.0'
            },
            'LANGUAJE' : {
                'TITULO': 'Test languaje',
                'BADGE': '69'
            },
            'LOGIN' : {
                'TITULO': 'Test login',
                'BADGE': '69'
            },
            'PROFILECREATOR' : {
                'TITULO': 'Profielschepper',
                'BADGE': '69'
            },
            'PROFILELIST': {
                'TITULO': 'Bedrijfsinformatie',
                'BADGE': '69'
            },
            'NOPRODUCTOS' : {
                'TITULO': 'U heeft geen producten',
                'BADGE': '69'
            },
            'RESPTI': {
              'TITULO': 'IT-manager'
            },
            'REQTEC': {
              'TITULO': 'Technische eisen'
            },
            'CLOUD': {
              'TITULO': 'Bestandsbeheerder',
              'TITULO_ESPANA': 'Report Downloads',
            },
            //Cultuur Audit
            'CULTURE': {
              'TITULO': 'Cultuuraudit'
            },
            //Cultuur Audit2
            'CULTURE2': {
              'TITULO': 'Cultuuraudit 5.0'
            },
            //Cultuur Auditopleiding
            'CATR': {
              'TITULO': 'Culturele auditopleiding'
            },
            //Feedback
            'FEEDBACK': {
              'TITULO': 'Terugkoppeling'
            },
            //Acercade
            'ABOUT': {
              'TITULO': 'Changelog'
            },
            'QUESTIONS': {
                'TITULO': 'Meest gestelde vragen'
              },
              'VIDEOS': {
                'TITULO': 'Instructievideos'
              },
              'CONSULTAR_E': {
                'TITULO': 'Onderzoekingen raadplegen'
              },
              'CALEND_SUR': {
                'TITULO':'Enquête Kalender'
              },
              'VIDEOSADMIN': {
                'TITULO': 'Beheerdersvideo'
              },
            'AUDITORIA-AUTO': {
              'TITULO': 'Geautomatiseerde audit'
            }, 'LOG_SISTEMA': {
              'TITULO': 'Systeemlogboek'
            }, 'TIPS': {
              'TITULO': 'Norma tips'
            }, 'ENCUESTA': {
              'TITULO': 'Colaboradores nuevos'
            }, 'CULTURETURQUIA1': {
              'TITULO': 'Culture Brief ve Culture Audit 5.0'
            }, 'CULTURETURQUIA2': {
              'TITULO': 'Culturele samenvatting 5.0'
            }, 'CULTURETURQUIA3': {
              'TITULO': 'Cultuuraudit 5.0'
            },

            'CULTUREMX1': {
              'TITULO': 'Cultuuraudit 5.0'
            }, 'CULTUREMX2': {
              'TITULO': 'Cultuuraudit  Costa Rica'
            }, 'CULTUREMX3': {
              'TITULO': 'Cultuuraudit  GoFlow'
            }, 'CULTUREMX4': {
              'TITULO': 'Cultuuraudit t 5.0 Panama'
            }, 'CULTUREMX5': {
              'TITULO': 'Cultuuraudit 5.0 Strategische partners'
            },
            'CULTUREMX11': {
              'TITULO': 'SP 2022'
            },
            'CULTUREMX12': {
              'TITULO': 'Cultuur-audit GoFlow 2-2022'
            },
            'CULTUREMX13': {
              'TITULO': 'Cultuur Audit Standaard 1'
            },
            'CULTUREMX14': {
              'TITULO': 'Cultuur Audit® CA&C'
            },
            'CULTUREMX15': {
              'TITULO': 'Cultuur Audit (certificeren) 2022'
            },
            'CULTUREMX16': {
              'TITULO': 'Cultuur Audit (certificeren, rkg.) 2022'
            },
            'CULTUREMX17': {
              'TITULO': 'Cultuur Audit (certificeren, rkg. en adic.) 2022'
            },
            'CULTUREMX18': {
              'TITULO': 'Cultuur Audit (certificeren, rkg. en adic.) 2024'
            },
            'CULTUREMX19': {
              'TITULO': 'Cultuurnota (certificeren) 2024'
            },
            'CULTUREMX20': {
              'TITULO': 'Cultuuraudit (certificeren en rangschikken) 2024'
            },
            'CULTURECH1': {
              'TITULO': 'Cultuuraudit'
            }, 'CULTURECH2': {
              'TITULO': 'Cultuuraudit 5.0'
            }, 'CULTURECH3': {
              'TITULO': 'Cultuuraudit SP'
            },

            'CULTUREESP1':{
              'TITULO': 'Cultuuraudit'
            },
            'CULTUREESP2':{
              'TITULO': 'Cultuuraudit 5.0'
            },
            'CULTUREESP3':{
              'TITULO': 'Actieplan'
            },
            'CULTUREBRI':{
              'TITULO': 'Cultuur in het kort',
              'Culture Brief': 'Cultuur in het kort',
            },
            'CULTUREAUDI':{
              'TITULO': 'Cultuur Audit',
              'Culture Audit': 'Cultuur Audit',
            },
            'CONTACTO':{
              'TITULO': 'Contact'
            },
            'ACTIONGOADMIN':{
              'TITULO': 'Action GO® beheerder'
            },
            'ACTIONGO':{
              'TITULO': 'Action GO®'
            },
            'LEADERGOADMIN':{
              'TITULO': 'Leider GO® beheerder',
            },
            'LEADERGOUSER':{
              'TITULO': 'Leider GO®',
            },
            'medir_INNO':{
              'TITULO': 'Innmotion onderzoek',
            },
            'CULTURE_OZEL':{
              'TITULO': 'Speciale Lijst',
            },
            'Culture_Ozel_TR1':{
              'TITULO': 'Sociale verantwoordelijkheid en vrijwilligerswerk',
            },
            'CONTROL_SURVE':{
              'TITULO': 'Controle',
            },
            'CONSUL_REQUE':{
              'TITULO': 'Eisen raadplegen',
            },
            'SURVEY_GENERIC':{
              'TITULO': 'Generiek enquêteverslag',
            },




        }
    }
};
